(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ContractProfil', ContractProfil);

    ContractProfil.$inject = ['$resource'];

    function ContractProfil ($resource) {
        var resourceUrl =  'api/profil-contract/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
